import { GlobalAppState } from '@model/state';

export const getPromoBannerData = (state: GlobalAppState) => state.promoBanner.data;
